module.exports = __webpack_public_path__ + "img/answer2.be9a3445.png";